<template>
  <div class="home-banner-box">
    <div class="slide-box">
      <div class="swiper-container advertisement-scroll scroll-box">
        <ul class="swiper-wrapper">
          <li
            class="swiper-slide"
            v-for="(item,index) in bannerImage"
            :key="index"
          >
            <span>
              <img :src="item.img" alt="德阳经开科创创新创客中心" draggable="false" />
            </span>
          </li>
        </ul>
        <div class="swiper-pagination swiper-advertise-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/../static/css/swiper-4.4.1.min.css";
import Swiper from "@/../static/js/swiper-4.4.1.min.js";

export default {
  name: "home_banner_cpn",
  data() {
    return {
      bannerImage: [
        // { img: require("../../assets/home/banner.jpg") },
        // { img: require("../../assets/home/banner2.jpg") },
        // { img: require("../../assets/home/banner3.jpg") },
        // { img: require("../../assets/home/banner4.jpg") }
        { img: require("../../assets/home/banner5.png") },
        { img: require("../../assets/home/banner6.png") },
        { img: require("../../assets/home/banner7.jpg") },
        // { img: require("../../assets/home/banner8.jpg") }
      ],
      advertisementSwiper: null
    };
  },
  mounted() {
    this.initAdvertisementSwiper();
  },
  methods: {
    initAdvertisementSwiper: function() {
      this.advertisementSwiper = new Swiper(".advertisement-scroll", {
        speed: 1000,
        autoplay: {
          delay: 3000
        },
        effect: "fade",
        slidesPerView: "auto",
        loop: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-advertise-pagination"
        }
      });
    },
    routeToQinKe() {
      window.open("https://qingke.imarsbox.com/", "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
// .set-banner-width(@width) when (@width<=1600px) {
//   width: 1600px;
//   background: #000;
// }

.home-banner-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 543px;
  .slide-box {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 543px;
    .scroll-box {
      width: 100%;
      height: 100%;
      & > ul {
        & > li {
          width: 100%;
          cursor: pointer;
          & > span {
            display: flex;
            width: 100%;
            height: 100%;
            & > img {
              display: block;
              width: 100%;
              // height: 100%;
              flex-grow: 1;
              object-fit: cover;
            }
          }
        }
      }
      .swiper-pagination {
        position: absolute;
        bottom: 0;
        padding-bottom: 30px;
      }
    }
    .appointment-box {
      position: absolute;
      width: 1200px;
      height: 820px;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
<style>
.swiper-pagination-bullet {
  display: inline-block;
  width: 40px;
  height: 4px;
  border-radius: 0;
  opacity: 1;
  background: #fff;
}

.swiper-pagination-bullet-active {
  background: #ff7800;
}
</style>




// WEBPACK FOOTER //
// src/components/home/home_banner_cpn.vue